// Translations
import phoneVerificationDialog from '../components/phone-verification-dialog/translations/en'

// Translation: Model > Phone number verifier (English)
export default Object.freeze({
	actions: {
		verify: 'Verify'
	},
	components: { phoneVerificationDialog }
})
